import styled from "styled-components";

export default styled.div`
  // position: relative;
  // top: -5rem;
  // left: 88%;
  // margin-top: 1rem;
  // font-size: 1.2rem;
  // cursor: pointer;
  // color: #738a94;

  // &:hover {
  //   color: #ff5d4c;
  // }

  // @media (min-width: 550px) {
  //   top: -3rem;
  //   left: 90%;
  //   font-size: inherit;
  //   margin-top: 3rem;
  // }
`;
